import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=70a199bf&scoped=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"
import style0 from "./errorPage.vue?vue&type=style&index=0&id=70a199bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a199bf",
  null
  
)

export default component.exports